export class ClienteModel{
    constructor(
        public mail_venta: String,
        public mail_prove: String,
        public tel_venta: String,
        public tel_prove: String
    ){}
  
    static clone(obj: ClienteModel){
        return new ClienteModel(obj.mail_venta,obj.mail_prove,obj.tel_venta,obj.tel_prove);
    }
  
    static fromJson(obj: any){
        return new ClienteModel(obj.mail_venta,obj.mail_prove,obj.tel_venta,obj.tel_prove);
    }
  
    static new(){
        return new ClienteModel('','','','');
    }
  }